import React from 'react'
import PropTypes from 'prop-types'
import * as S from './styled'

/**
    Uso:
    <Icon
        Source={CloseIcon} -> Source del icono en src/assets/icons/index.ts
        width={'22px'} -> width
        height={'22px'} -> height
        color={'#FF7E00'} -> color (#FF7E00 por defecto)
    />
*/

const Icon = ({ Source, width, height, color, onClick, title, tooltip, tooltipTitle, position }) => {
  return (
    <S.IconContainer
      className='icon-container'
      color={color}
      width={width}
      height={height}
      onClick={onClick}
      title={title}
      position={position}
    >
      <Source title={title} className='icon' width={width} height={height} />
      {tooltip && <S.Tooltip className='tooltip'>{tooltipTitle}</S.Tooltip>}
    </S.IconContainer>
  )
}

Icon.defaultProps = {
  Source: {},
  width: '20px',
  height: '20px',
  color: S.defaultColor,
  onClick: null,
  title: '',
  tooltip: false,
  tooltipTitle: '',
  position: '',
}

Icon.propTypes = {
  Source: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string,
  tooltip: PropTypes.bool,
  tooltipTitle: PropTypes.string,
  position: PropTypes.string,
}

export default Icon
